export const faqCategories = [
  {
    title: "General",
    items: [
      { q: "What makes Natalia Medical Aesthetics different?", a: "Every treatment plan is personalised, evidence-based and performed by Natalia herself, drawing on over two decades of medical experience. We prioritise natural-looking results over trends." },
      { q: "Is a consultation required before a treatment?", a: "Yes. A thorough consultation ensures your safety, aligns expectations and allows us to design a plan that respects your unique skin, lifestyle and goals." },
      { q: "Are treatments suitable for all skin types and tones?", a: "Most of our treatments are safe across skin types and tones. During your consultation we assess and adapt each protocol to your skin, medical history and objectives." }
    ]
  },
  {
    title: "Booking & Consultation",
    items: [
      { q: "How do I book a consultation?", a: "You may book via the Book Consultation page, send us an SMS or reach us on Instagram. We aim to respond within one business day." },
      { q: "How long is a consultation?", a: "Consultations are typically 45–60 minutes. This time allows for a proper medical assessment, discussion and treatment planning." },
      { q: "Is there a consultation fee?", a: "Yes, a small consultation fee applies and is credited toward your first treatment if booked within 30 days." }
    ]
  },
  {
    title: "Treatments",
    items: [
      { q: "How do I know which treatment is right for me?", a: "Your consultation is the answer. Natalia will assess your skin and goals, then recommend the protocol that matches your needs — often a curated combination." },
      { q: "How natural will the results look?", a: "Natural-looking results are our philosophy. We aim to enhance your features rather than transform them, so friends notice you look well, not treated." },
      { q: "Can I combine treatments?", a: "Yes — many of our clients benefit from bespoke, layered protocols. Natalia will design a sequence that maximises results while respecting healing." }
    ]
  },
  {
    title: "Safety & Aftercare",
    items: [
      { q: "Are your treatments safe?", a: "All treatments are performed with medical-grade, FDA-cleared or Health Canada-approved technology in a sterile clinical environment by a trained Master Aesthetician with medical education and advanced professional training." },
      { q: "Will I be given aftercare instructions?", a: "Yes. You will receive detailed aftercare guidance verbally and in writing, and we remain available should you have any questions between visits." },
      { q: "Is downtime required?", a: "Downtime varies by treatment — from none at all to a few days. This is discussed transparently during your consultation." }
    ]
  }
];
